import Enum from './Enum.js';

export default class SalaryReviewTermStatus extends Enum {
  static OPEN = new SalaryReviewTermStatus('OPEN', '下書き');
  static CLOSED = new SalaryReviewTermStatus('CLOSED', '確定済');
}
